import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import soccer_image from "../../Assets/Images/soccer_image.png";
import football1 from "../../Assets/Images/football1.png";
import football2 from "../../Assets/Images/new/p21.png";
import football3 from "../../Assets/Images/football21.png";
import football4 from "../../Assets/Images/new/p121.png";
import football5 from "../../Assets/Images/foot7.png";
import soccer_banner_image from "../../Assets/Images/foot_bg2.png";
import soccer_banner_image2 from "../../Assets/Images/new/p11.png";
import stock_photo from "../../Assets/Images/football3.png";
import dribbling from "../../Assets/Images/new/p12.png";
import shooting from "../../Assets/Images/shooting.png";
import passing from "../../Assets/Images/passing.png";
import defense from "../../Assets/Images/defense.png";
import rebounding from "../../Assets/Images/rebounding.png";
import soccer_trainer1 from "../../Assets/Images/basketball_trainer1.png";
import soccer_trainer2 from "../../Assets/Images/basketball_trainer2.png";
import soccer_trainer3 from "../../Assets/Images/basketball_trainer3.png";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Football() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  return (
    <>
      <SEO
        title="Instruction | Football | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/football"
      />
      <div className="football-container">
        <div className="football-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="football-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="football-header-content">
              <h1 className="black-text-clip">Football</h1>
              <h3 className="black-text-clip">
                Kickoff Your Child's Football Journey with bwc sports!
              </h3>
              <h5 className="black-text-clip">
                Fuel Your Child’s Passion for Soccer with Staten Island’s
                Premier Soccer Program
              </h5>
              <p className="black-text-clip">
                BWC Football Training is dedicated to developing the skills of
                young athletes through comprehensive and innovative training
                sessions. Our mission is to foster a deep understanding and love
                for football, while promoting physical fitness, teamwork, and
                personal growth. Our expert trainers provide personalized
                coaching that focuses on both fundamental skills and advanced
                techniques. We create a supportive and motivating environment
                where athletes can thrive, emphasizing the importance of
                discipline, sportsmanship, and a strong work ethic. With
                tailored training sessions and state-of-the-art facilities, we
                aim to enhance individual performance and improve overall team
                dynamics. At BWC Football Training, we are committed to shaping
                the next generation of football players.
              </p>
            </div>
          </div>
        </div>
        <div className="football-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one football-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        <div className="football-image-container">
          <img src={football1} alt="soccer-image" />
          <img src={football2} alt="soccer-image" />
          <img src={football3} alt="soccer-image" />
          <img src={football4} alt="soccer-image" />
        </div>
        <div className="football-section2">
          <h3 className="black-text-clip">Why Choose BWC FOOTBALL?</h3>
          <p className="black-text-clip">
            At BWC Football, we offer a range of programs that are as
            comprehensive as they are fun. Our goal is to provide every player
            with the tools they need to succeed, both on and off the field. Our
            carefully designed drills and games create an environment where
            learning is exciting and improvement is inevitable.
          </p>
          <div className="football-section2-image-container">
            <span className="football-overlay-text bottom-left bg-left">
              1-on-1 Training
            </span>
            <span
              className="football-overlay-text top-right "
              style={{ textAlign: "end" }}
            >
              Group Training
            </span>
            <img src={soccer_banner_image} alt="soccer-image-session" />
          </div>
        </div>

        <div className="football-section3">
          <h3 className="black-text-clip">Dive into Our Exciting Programs</h3>
          <p className="black-text-clip">
            Our programs are packed with a variety of drills and games designed
            to sharpen your skills and boost your confidence:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={football1} alt="Passing" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Passing</div>
                <div className="sc-card-desc">
                  Develop accuracy and timing for both short and long throws.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccer_banner_image2} alt="Catching" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Catching</div>
                <div className="sc-card-desc">
                  Focus on hand-eye coordination and grip to secure the ball.
                </div>
              </div>
            </div>

            <div className="sc-card">
              <img src={stock_photo} alt="Blocking" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Blocking</div>
                <div className="sc-card-desc">
                  Train on proper stance, footwork, and leverage to protect your
                  quarterback or create lanes for the running back.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={dribbling} alt="Tackling" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Tackling</div>
                <div className="sc-card-desc">
                  Improve defensive skills by practicing proper tackling
                  techniques to ensure safety and effectiveness.
                </div>
              </div>
            </div>

            <div className="sc-card">
              <img src={football5} alt="Route Running" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Route Running</div>
                <div className="sc-card-desc">
                  Develop precision and speed in running routes. Practice quick
                  cuts, fakes, and timing to create separation.
                </div>
              </div>
            </div>
            {/* <div className="soccer_section_image_cont"><span className="skill-text-overlay">Passing</span><img src={soccerSkill1} alt="Shooting" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Shooting</span><img src={soccerSkill2} alt="Passing" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Defending</span><img src={soccerSkill3} alt="Defense" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Goal Keeping</span><img src={soccerSkill4} alt="Rebounding" /></div> */}
          </div>
        </div>
        <div className="football-section4">
          <h3 className="black-text-clip">Scrimmages and Games</h3>
          <p className="black-text-clip">
            Practice makes perfect, but nothing beats game day. Our scrimmages
            and games give players the chance to apply what they’ve learned in a
            real-game setting, building confidence and experience. We cater to
            all skill levels, from ages 4 to 18, ensuring that every player
            finds their place on the field.
          </p>
        </div>
        <div className="football-booking-container2">
          <div className="football-booking-container-details">
            <h3>READY TO GET STARTED?</h3>
            <p>
              Don’t miss out on this incredible opportunity to give your child
              the best start in soccer. Our spots fill up fast—secure your place
              today!
            </p>
            <p>
              <strong>Sign Up Now</strong> – Empower your child to succeed on
              and off the court.
            </p>
          </div>
          <div
            id="inside-booking-container"
            className="football-booking-container "
          >
            <button
              className="one-on-one"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("1-1")}
            >
              <span className="black-text-clip">
                Schedule 1-on-1 Class Here
              </span>
            </button>
            <button
              className="one-on-one"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("Group")}
            >
              <span className="black-text-clip">Schedule Group Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one football-booking-selected"
                style={{ cursor: "pointer" }}
                onClick={() => handleSubmit("")}
              >
                Sign Up for Classes Here
              </button>
            )}
          </div>
        </div>
        <div className="football-booking-container outside-booking-container">
          <button
            className="one-on-one"
            style={{ cursor: "pointer" }}
            onClick={() => handleSubmit("1-1")}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            style={{ cursor: "pointer" }}
            onClick={() => handleSubmit("Group")}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one football-booking-selected"
              style={{ cursor: "pointer" }}
              onClick={() => handleSubmit("")}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        {/* 
                <div className="football-trainers">
                    <h3>Our Trainers</h3>
                    <div className="football-trainer-image-container">
                        <div className="football-trainer-image">
                           
                            <img src={soccer_trainer1} alt="trainer-image" />

                        </div>
                        <div className="football-trainer-image">
                           
                            <img src={soccer_trainer2} alt="trainer-image" />

                        </div>
                        <div className="football-trainer-image">
                           
                            <img src={soccer_trainer3} alt="trainer-image" />

                        </div>
                    </div>
                </div> */}
        <div className="football-locations">
          <h3 className="black-text-clip">Locations</h3>
          <div className="football-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24228.92735189222!2d-74.14155600000001!3d40.61629700000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c3387658829%3A0x770465e3707ce954!2sChurch%20of%20the%20Holy%20Family%2C%20366%20Watchogue%20Rd%2C%20Staten%20Island%2C%20NY%2010314!5e0!3m2!1sen!2sus!4v1773670275179!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Holy Family</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24231.337763431424!2d-74.164119!3d40.60965!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c5bcf5261eb%3A0xea6d9265f869f29d!2s100%20Merrill%20Ave%2C%20Staten%20Island%2C%20NY%2010314!5e0!3m2!1sen!2sus!4v1773672188930!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Moore Catholic High School</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24258.30795685743!2d-74.239816!3d40.535215!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773672234908!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
